import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const HomeStory = () => (
  <section className="relative overflow-hidden bg-ink border-y border-line" data-testid="home-story-section">
    <div className="absolute inset-0 opacity-25 pointer-events-none" style={{
      background: "radial-gradient(ellipse at 15% 15%, rgba(29,169,218,0.35), transparent 55%), radial-gradient(ellipse at 85% 85%, rgba(164,197,57,0.25), transparent 55%)",
    }} />
    <div className="relative max-w-7xl mx-auto px-6 sm:px-12 py-24 sm:py-32">
      <div className="max-w-3xl">
        <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-accent">
          [ Eine wahre Geschichte · 42 Sekunden ]
        </div>
        <h2 className="mt-6 font-display font-black text-4xl sm:text-6xl lg:text-7xl tracking-tightest leading-[0.98] text-white">
          Quartalsende.<br />
          <span className="text-accent">Eine Praxis, gerettet.</span>
        </h2>
        <p className="mt-6 text-white/75 text-lg leading-relaxed max-w-2xl">
          Donnerstag, 20:17 Uhr. Die Abrechnung läuft – und auf einem Praxis-PC stimmt etwas nicht. Wie unsere Managed-Security-Kette in vier Akten aus einer Beinahe-Katastrophe eine Randnotiz gemacht hat – und warum die Praxis heute dank kontinuierlichem Schwachstellenmanagement gar nicht erst in Gefahr gerät.
        </p>
      </div>

      {/* 16:9 responsive iframe stage */}
      <div className="mt-12 relative w-full border border-white/15 bg-black shadow-glow overflow-hidden" style={{ aspectRatio: "16 / 9" }}>
        <iframe
          src="/it-servicepoint-story.html"
          title="IT-Servicepoint Success Story – Praxis am Quartalsende gerettet"
          data-testid="home-story-frame"
          className="absolute inset-0 w-full h-full"
          loading="eager"
          allow="autoplay"
        />
      </div>

      <div className="mt-10 flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
        <p className="text-white/60 text-sm max-w-xl">
          Klingt vertraut? Wir zeigen Ihnen gern, wie diese Kette bei Ihnen aussehen könnte.
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <Link
            to="/managed-services"
            data-testid="home-story-cta-services"
            className="group inline-flex items-center justify-center gap-2 px-6 py-3 bg-accent text-ink font-medium hover:bg-accent/90 transition-colors"
          >
            Managed Services entdecken
            <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          </Link>
          <Link
            to="/kontakt"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-white/30 text-white hover:bg-white/10 transition-colors"
          >
            Kostenfreies Erstgespräch
          </Link>
        </div>
      </div>
    </div>
  </section>
);
